(function () {
    angular.module('tmx-app').controller('pjpSummaryCtrl', ['resolvedData','menu','PjpSummaryService','tmxUtility', PjpSummaryCtrl]);
    function PjpSummaryCtrl(resolvedData,menu,PjpSummaryService,tmxUtility) {
        var PjpSummaryVM = this;
        PjpSummaryVM.vm = new PjpSummaryService();
        PjpSummaryVM.users = resolvedData.Users.data;
        PjpSummaryVM.pjpList=resolvedData.PJPList.data;
        PjpSummaryVM.agentTab=true;
        PjpSummaryVM.pjpTab=false;
        PjpSummaryVM.agentClick=agentClick;
        PjpSummaryVM.pjpClick=pjpClick;
        PjpSummaryVM.agentChanged=agentChanged;
        PjpSummaryVM.pjpChanged=pjpChanged;
        PjpSummaryVM.menu=menu;

        PjpSummaryVM.showScheduler=false;
        PjpSummaryVM.showAgentName=false;  
        var today = new Date();                    
        today= tmxUtility.formatDateSpecific(today,"YYYY/MM/DD");

        var workDayStart = "08:00 AM";
        var workDayEnd = "08:00 PM";

        function agentClick() {
            PjpSummaryVM.showAgentName=false;
            PjpSummaryVM.agentTab=true;
            PjpSummaryVM.pjpTab=false;
            PjpSummaryVM.showScheduler=false;
            PjpSummaryVM.vm.PjpMasterId=null;
        }

        function pjpClick() {
            PjpSummaryVM.showAgentName=false;
            PjpSummaryVM.agentTab=false;
            PjpSummaryVM.pjpTab=true;
            PjpSummaryVM.showScheduler=false;
            PjpSummaryVM.vm.UserId=null;
        }


        function agentChanged(value)        
        {
            PjpSummaryVM.showScheduler=false;                      
            if(tmxUtility.exists(value)){
            PjpSummaryService.getByAction('GetPJPByUserId/' + value, true, 'get').then(function (response) {                                           
            if(tmxUtility.exists(response) && response.status.code==200)
             {
                    PjpSummaryVM.showScheduler=true;
                    var data=response.data;                   
                    PjpSummaryVM.taskList = [];
                                   data.forEach(function (pjp){
                                        var clusters = pjp.TmxPjpCluster;
                                        var LoanApplicationPjp = pjp.TmxLoanApplicationPjp;
                                        var geofencePjp = pjp.TmxGeofencePjp;                                                                              
                                        clusters.forEach(function (cluster) {
                                            var PJPDate = new Date(cluster.PjpDate + 'Z');                                            
                                            LoanApplicationPjp.forEach(function (loan) {                                                
                                                PjpSummaryVM.task = {
                                                    "TaskID": cluster.PjpClusterId + '-' + loan.LoanApplicationPjpId,
                                                    "PJPType": loan.PJPType,
                                                    "Description": pjp.PjpName,
                                                    "StartTimezone": null,
                                                    "Start": PJPDate,
                                                    "End": PJPDate,
                                                    "EndTimezone": null,
                                                    "RecurrenceRule": null,
                                                    "RecurrenceID": null,
                                                    "RecurrenceException": null,
                                                    "IsAllDay": false,
                                                    "PJPMaster":pjp.PjpName,
                                                    "LoanApplicationCode":loan.TmxLoanApplicationVW == null ? '': loan.TmxLoanApplicationVW.LoanApplicationNumber,
                                                    "CustomerName":loan.TmxLoanApplicationVW == null ? '': loan.TmxLoanApplicationVW.CustomerName,
                                                    "GeofenceName":"",
                                                    "GeofenceCode":""                                                 
                                                };
                                                PjpSummaryVM.taskList.push(PjpSummaryVM.task);
                                            });

                                            geofencePjp.forEach(function (geofence) {                                            
                                                PjpSummaryVM.task = {
                                                    "TaskID": cluster.PjpClusterId + '-' + geofence.GeofencePjpId,
                                                    "PJPType": geofence.PJPType,
                                                    "Description": pjp.PjpName,
                                                    "StartTimezone": null,
                                                    "Start": PJPDate,
                                                    "End": PJPDate,
                                                    "EndTimezone": null,
                                                    "RecurrenceRule": null,
                                                    "RecurrenceID": null,
                                                    "RecurrenceException": null,
                                                    "IsAllDay": false,
                                                    "PJPMaster":pjp.PjpName,
                                                    "LoanApplicationCode":"",
                                                    "CustomerName":"",
                                                    "GeofenceName":geofence.TmxGeofence.GeofenceName,
                                                    "GeofenceCode":geofence.TmxGeofence.GeofenceCode
                                                };
                                                PjpSummaryVM.taskList.push(PjpSummaryVM.task);
                                            });
                                        });                                        
                                    });                                    
                                SetScheduler();                                    
                }


            });
        }
        }


        function pjpChanged(value)        
        {                        
            PjpSummaryVM.showAgentName=false;
            PjpSummaryVM.showScheduler=false;            
            if(tmxUtility.exists(value)){
             PjpSummaryService.getByAction('GetPJPById/' + value, false, 'get').then(function (response) {                                           
                if(tmxUtility.exists(response) && response.status.code==200)
                    {
                    PjpSummaryVM.showScheduler=true;
                    var data=response.data;                     
                    PjpSummaryVM.showAgentName=true;
                    PjpSummaryVM.vm.Agent=PjpSummaryVM.users.find(x=>x.HiddenValue==data.UserId).VisibleValue;
                    PjpSummaryVM.taskList = [];                                    
                    var clusters = data.TmxPjpCluster;
                    var LoanApplicationPjp = data.TmxLoanApplicationPjp;
                    var geofencePjp = data.TmxGeofencePjp;                                                                               
                    clusters.forEach(function (cluster) {
                        var PJPDate = new Date(cluster.PjpDate + 'Z');                                            
                        LoanApplicationPjp.forEach(function (loan) {                                                
                            PjpSummaryVM.task = {
                                "TaskID": cluster.PjpClusterId + '-' + loan.LoanApplicationPjpId,
                                "PJPType": loan.PJPType,
                                "Description": data.PjpName,
                                "StartTimezone": null,
                                "Start": PJPDate,
                                "End": PJPDate,
                                "EndTimezone": null,
                                "RecurrenceRule": null,
                                "RecurrenceID": null,
                                "RecurrenceException": null,
                                "IsAllDay": false,
                                "PJPMaster":data.PjpName,
                                "LoanApplicationCode":loan.TmxLoanApplicationVW == null ? '': loan.TmxLoanApplicationVW.LoanApplicationNumber,
                                "CustomerName":loan.TmxLoanApplicationVW == null ? '': loan.TmxLoanApplicationVW.CustomerName,
                                "GeofenceName":"",
                                "GeofenceCode":""  
                            };
                            PjpSummaryVM.taskList.push(PjpSummaryVM.task);
                        });

                        geofencePjp.forEach(function (geofence) {                                            
                            PjpSummaryVM.task = {
                                "TaskID": cluster.PjpClusterId + '-' + geofence.GeofencePjpId,
                                "PJPType": geofence.PJPType,
                                "Description": data.PjpName,
                                "StartTimezone": null,
                                "Start": PJPDate,
                                "End": PJPDate,
                                "EndTimezone": null,
                                "RecurrenceRule": null,
                                "RecurrenceID": null,
                                "RecurrenceException": null,
                                "IsAllDay": false,
                                "PJPMaster":data.PjpName,
                                "LoanApplicationCode":"",
                                "CustomerName":"",
                                "GeofenceName":geofence.TmxGeofence.GeofenceName,
                                "GeofenceCode":geofence.TmxGeofence.GeofenceCode
                            };
                            PjpSummaryVM.taskList.push(PjpSummaryVM.task);
                        });
                    });     
               
                    SetScheduler();                    
                }


            });
        }
        }

        function scheduler_edit(e) {                                                
                var buttonsContainer = e.container.find(".k-edit-buttons");
                if(tmxUtility.exists(buttonsContainer)){
                buttonsContainer.hide();  
                
                
                var LoanApplicationCode=e.event.loanApplicationCode;
                if(LoanApplicationCode=="")
                {
                    document.getElementById('loanApplicationCode').style.display='none';                    
                }

                var CustomerName=e.event.customerName;
                if(CustomerName=="")
                {
                    document.getElementById('customerName').style.display='none';
                }

                var geofenceName=e.event.geofenceName;
                if(geofenceName=="")
                {
                    document.getElementById('geofenceName').style.display='none';
                }

                var geofenceCode=e.event.geofenceCode;
                if(geofenceCode=="")
                {
                    document.getElementById('geofenceCode').style.display='none';
                }
            }
        }

        function SetScheduler()
        {                        
            PjpSummaryVM.ds = new kendo.data.SchedulerDataSource({
                transport: {
                    read:function (o) {
                        o.success(PjpSummaryVM.taskList);
                    },
                    dataType: "json"
                },                
                schema: {
                  model: {
                    id: "taskId",
                    fields: {
                        taskId: { from: "TaskID" },
                        title: { from: "PJPType", validation: { required: true } },
                        start: { type: "date", from: "Start" },
                        end: { type: "date", from: "End" },
                        startTimezone: { from: "StartTimezone" },
                        endTimezone: { from: "EndTimezone" },
                        description: { from: "Description" },
                        recurrenceId: { from: "RecurrenceID" },
                        recurrenceRule: { from: "RecurrenceRule" },
                        recurrenceException: { from: "RecurrenceException" },
                        isAllDay: { type: "boolean", from: "IsAllDay" },
                        pjpMaster: { type:"text",from:"PJPMaster" },
                        loanApplicationCode: { from:"LoanApplicationCode" },
                        customerName: { from:"CustomerName" },
                        geofenceName: { from:"GeofenceName" },
                        geofenceCode: { from:"GeofenceCode" },                        

                      }
                    }
                }
                });


            PjpSummaryVM.schedulerOptions = {
                date: today+ 'Z',
                workDayStart: new Date("2020/1/1 " + workDayStart),
                workDayEnd: new Date("2020/1/1 " + workDayEnd),
                showWorkHours: true,                        
                dateHeaderTemplate: kendo.template("<strong>#=kendo.toString(kendo.parseDate(date), 'dd MMM, yyyy')#</strong>"),
                views: [
                    { type: "day", dateHeaderTemplate: "<span class='k-link k-nav-day'>#=kendo.toString(kendo.parseDate(date),'ddd, dd MMM, yyyy')#</span>" },
                    { type: "workWeek", dateHeaderTemplate: "<span class='k-link k-nav-day'>#=kendo.toString(date, 'ddd, dd MMM')#</span>" },
                    { type: "week", dateHeaderTemplate: "<span class='k-link k-nav-day'>#=kendo.toString(date, 'ddd, dd MMM')#</span>" },
                    { type: "month", selected: true },
                ],                
                editable: {
                    template: $("#customEditorTemplate").html(),
                    window: {
                        title: "PJP Detail"                       
                    },
                    
                  },
                  eventTemplate: $("#event-template").html(),            
                edit: scheduler_edit,                
                dataSource: PjpSummaryVM.ds,                                
            };
        }
    }
})();
